/* eslint-disable no-unused-vars */
import angular from 'angular';
import { sumBy, toNumber } from 'lodash';

module.exports = angular.module('common.models.ugm-summary', [])
.factory('ugmSummary', function() {

  class UgmCategory {
    constructor(name, fields) {
      this.name = name;
      this.fields = fields;
    }

    getTotal(uea, offer, isAtUnderwriting) {
      return sumBy(this.fields, field => field.value(uea, offer, isAtUnderwriting));
    }
  }

  return [
    new UgmCategory(
      'Opendoor Fee',
      [
        {
          name: 'Opendoor Fee',
          value: (uea, offer, isAtUnderwriting) => toNumber(
              isAtUnderwriting ?
                uea.underwriting_fee_cost_cents :
                offer.fee_cost_cents
            )
        }
      ]
    ),
    new UgmCategory(
      'Accuracy Gain/Loss',
       [
        {
          name: 'ARV',
          value: (uea, offer, isAtUnderwriting) => toNumber(
            isAtUnderwriting ?
              uea.uw_post_repair_valuation_cents :
              offer.post_repairs_valuation_cents
          )
        },
        {
          name: 'Purchase Price',
          value: (uea, offer, isAtUnderwriting) => -toNumber(
              isAtUnderwriting ?
                  uea.underwriting_recorded_price_cents :
                  offer.recorded_price_cents
          )
        },
        {
          // Broken out so that we do not bias underwriters with a resale price higher than their
          // submitted ARV.
          name: 'Val Cost (Val Gain, RBP)',
          value: (uea, offer, isAtUnderwriting) => toNumber(uea.cost_valuation_cents)
        },
        {
          name: 'Seller Credit',
          // Exclude Repair credits here because it's counted separately.
          value: (uea, offer, isAtUnderwriting) =>
              toNumber(
                  uea.addendum_unit_total_cents -
                  uea.credit_repairs_cents
              )
        },
        {
          name: 'Seller Marketing Cost',
          value: (uea, offer, isAtUnderwriting) => toNumber(uea.cost_seller_marketing_cents)
        },
        {
          name: 'Renovation Costs',
          value: (uea, offer, isAtUnderwriting) => toNumber(uea.cost_renovations_cents)
        }
      ]
    ),
    new UgmCategory(
      'Net Repair Gain/Loss',
      [
        {
          name: 'Repair Credits',
          value: (uea, offer, isAtUnderwriting) => toNumber(uea.credit_repairs_cents)
        },
        {
          name: 'Repair Costs',
          value: (uea, offer, isAtUnderwriting) => toNumber(uea.cost_repairs_cents)
        },
        {
          name: 'BRN',
          value: (uea, offer, isAtUnderwriting) => toNumber(uea.cost_brn_cents)
        }
      ]
    ),
    new UgmCategory(
      'Holding Costs',
      [
        {
          name: 'Holding Costs',
          value: (uea, offer, isAtUnderwriting) => toNumber(uea.cost_holding_cents)
        }
      ]
    ),
    new UgmCategory(
      'Transaction Costs',
      [
        {
          name: 'Acquisition Costs',
          value: (uea, offer, isAtUnderwriting) => toNumber(uea.cost_acquisition_cents)
        },
        {
          name: 'Resale Costs',
          value: (uea, offer, isAtUnderwriting) => toNumber(uea.cost_resale_cents)
        }
      ]
    ),
    new UgmCategory(
      'Resale Broker Commissions',
      [
        {
          name: 'Resale Broker Commissions',
          value: (uea, offer, isAtUnderwriting) =>
              toNumber(uea.cost_resale_broker_commissions_cents)
        }
      ]
    )
  ];
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/models/ugm-summary.js
 **/